<div>
	<div class="o-grid o-grid--wrap">
		<div class="o-grid__cell--w-100 o-grid__cell" *ngIf="!vm.loading">
			<div class="c-card u-osb-md">
				<div class="c-content">
					<div class="o-grid o-grid--center-v">
						<div class="o-grid__cell">
							<div *ngIf="vm.isValidatePatientStep1">
								<label for="patientUserCheck" class="c-form__label u-osb-xs" >
									{{'PreVisit.Insert_For_Person.Patients_Identifier' | translate}}
								</label>
								<input type="text" id="patientUserCheck" name="patientUserCheck" class="c-form__input" [(ngModel)]="vm.userEstonianIdentificationCode"
												(keyup)="$event.keyCode === 13 && vm.validatePatientIdentifier()" autocomplete="off"/>
								<p id="showIdentifierDoesNotValidateErrorLabel" class="c-text c-text--s3 u-osb-xs" *ngIf="vm.showIdentifierDoesNotValidate">
									{{'PreVisit.Insert_For_Person.Identifier_Not_Valid' | translate}}
								</p>
								<p id="isUserConsentsNotGivenErrorLabel" class="c-text c-text--s3 u-osb-xs" *ngIf="vm.isUserConsentsNotGiven">
									{{'PreVisit.Insert_For_Person.Consents_Not_Given' | translate}}
								</p>
								<p id="isInserterAndPatientNotServicedBySameGpOrganizationErrorLabel" class="c-text c-text--s3 u-osb-xs" *ngIf="vm.isInserterAndPatientNotServicedBySameGpOrganization">
									{{'PreVisit.Insert_For_Person.Not_Serviced_By_Same_Gp_Organization' | translate}}
								</p>
								<p id="insuranceDataNotFoundErrorLabel" class="c-text c-text--s3 u-osb-xs" *ngIf="vm.isInsuranceDataNotFound">
									{{'PreVisit.Insert_For_Person.Insurance_Data_Not_Found' | translate}}
								</p>
								<button id="validatePatientIdentifierButton" type="button" class="c-button c-button--s1 u-ost-md" *ngIf="!vm.isValidatePatientStep2 && !vm.showCreateUserButton"
												(click)="vm.validatePatientIdentifier()">
									{{'PreVisit.Insert_For_Person.Search_User' | translate}}
								</button>
								
								<div *ngIf="vm.isValidatePatientStep2" [ngClass]="{ 'c-form__group--error': vm.noConnectionDefined }">
									<label for="patientUserCheck" class="c-form__label u-osb-xs u-ost-md">
										{{'PreVisit.Insert_For_Person.Connection_With_Patient' | translate}}
									</label>
									<label class="c-radio">
										<input type="radio" name="nextOfKin" [(ngModel)]="vm.requesterRelationshipToPatient" value="NOK">
										<span id="nextOfKinLabel">{{'PreVisit.Insert_For_Person.Next_Of_Kin' | translate}}</span>
									</label>
									<label class="c-radio">
										<input type="radio" name="dependant" [(ngModel)]="vm.requesterRelationshipToPatient" value="DEPEN">
										<span id="dependantLabel">{{'PreVisit.Insert_For_Person.Dependant' | translate}}</span>
									</label>
									<label class="c-radio">
										<input type="radio" name="delegatee" [(ngModel)]="vm.requesterRelationshipToPatient" value="DELEGATEE">
										<span id="delegateeLabel">{{'PreVisit.Insert_For_Person.Care_Taker' | translate}}</span>
									</label>
									<label class="c-radio">
										<input type="radio" name="contact" [(ngModel)]="vm.requesterRelationshipToPatient" value="CONT">
										<span id="contactLabel">{{'PreVisit.Insert_For_Person.Other_Contact' | translate}}</span>
									</label>
								</div>
	
								<button id="validatePatientIdentifierButton2" type="button" class="c-button c-button--s1 u-ost-md" *ngIf="vm.isValidatePatientStep2"
												(click)="vm.validatePatientIdentifier()">
									{{'PreVisit.Common.Forward' | translate}}
								</button>

							</div>
							
							<div *ngIf="vm.showCreateUserButton">
								<button id="showCreateUserModalButton" type="button" class="c-button c-button--s2 u-ost-md" (click)="vm.showCreateUserModal()">
									{{'PreVisit.Insert_For_Person.Create_User' | translate}}
								</button>
							</div>
							<div *ngIf="vm.isUserConsentsNotGiven">
								<button id="showGiveConsentsModalButton" type="button" class="c-button c-button--s2 u-ost-md" (click)="vm.showGiveConsentsModel()">
									{{'PreVisit.Insert_For_Person.Give_Consents' | translate}}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<loader-overlay *ngIf="vm.loading"></loader-overlay>
	</div>
</div>
